import { useState } from "react";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { useClickOutSide } from "../../../../hooks/useClickOutside";

export const TagsView = ({ tags = [], handleSetTags = () => {} }) => {
  const [isActive, setIsActive] = useState(false);
  const { inputRef } = useClickOutSide({ close: () => setIsActive(false) });

  return (
    <>
      {tags?.slice(0, 5)?.map((tag, index) => (
        <span
          key={index}
          className={`${globalStyles["statusBlock"]} white cursor-pointer`}
          style={{
            borderRadius: 0,
            minWidth: "auto",
          }}
          onClick={() => handleSetTags("{{" + tag + "}}")}
        >
          {"{{"}
          {tag}
          {"}}"}
        </span>
      ))}

      {tags?.length || 0 > 4 ? (
        <span className={styles.viewCover} ref={inputRef}>
          <span
            className="cursor-pointer purple--text small-text-size"
            onClick={() => setIsActive(true)}
          >
            View More
          </span>

          {isActive ? (
            <span className={styles.dropdown}>
              {tags?.slice(5)?.map((tag, index) => (
                <span
                  key={index}
                  className={`${globalStyles["statusBlock"]} white cursor-pointer px-0`}
                  style={{
                    borderRadius: 0,
                    minWidth: "auto",
                  }}
                  onClick={() => {
                    handleSetTags("{{" + tag + "}}");
                    setIsActive(false);
                  }}
                >
                  {"{{"}
                  {tag}
                  {"}}"}
                </span>
              ))}
            </span>
          ) : null}
        </span>
      ) : null}
    </>
  );
};
